import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { authGuard } from './app/core/auth.guard';
import { Companies } from './app/pages/companies/companies';
import { Users } from './app/pages/users/users';
import { SalesReport } from './app/pages/salesreport/salesreport';
import { Suppliers } from './app/pages/suppliers/suppliers';
import { HomeDashboard } from './app/pages/dashboard/home-dashboard';
import { DeliveryNotePage } from './app/pages/deliverynote/deliverynote';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', component: HomeDashboard },
            { path: 'fuel-dispatch', component: Dashboard, canActivate: [authGuard] },
            { path: 'companies', component: Companies, canActivate: [authGuard] },
            { path: 'users', component: Users, canActivate: [authGuard] },
            { path: 'sales', component: SalesReport, canActivate: [authGuard] },
            { path: 'suppliers', component: Suppliers, canActivate: [authGuard] },
            { path: 'delivery-note', component: DeliveryNotePage, canActivate: [authGuard] },
            { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
            { path: 'documentation', component: Documentation },
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
